/*
https://splidejs.com/guides/getting-started/
*/

import Splide from '@splidejs/splide';

document.addEventListener( 'DOMContentLoaded', function() {
    const slider = document.querySelector('.photo-gallery-section__bna__slider');

    if( slider ) {
        const counter = slider.querySelector('.slider-info .slider-numbers');

        var splide = new Splide( '.photo-gallery-section__bna__slider' , {
            type: 'slider',
            speed: 1000,
            arrows: true,
            pagination: false,
            rewind: false,
            perPage: 1,
            perMove: 1,
            gap: 10,
            waitForTransition: false,
            arrowPath: 'M8.354,0,0,8.353l8.354,8.354L9.06,16,1.915,8.853H16.707v-1H1.915L9.06.706Z'
        });
        splide.mount();

        // Function to update the counter
        function updateCounter(splide) {
            var currentSlide = splide.index + 1;  // +1 because index is 0-based
            var totalSlides = splide.length;
            counter.textContent = `${currentSlide}/${totalSlides}`;
        }

        // Initial counter update
        updateCounter(splide);

        // Update counter on slide change
        splide.on('move', function () {
            updateCounter(splide);
        });
    }
});